import React, { useContext, useState } from 'react';
import { CustomerContext } from '../CustomerContext';
import { useNavigate } from 'react-router-dom';
import { Error } from '@app/shared';

export default function CreateAddress() {
  const navigate = useNavigate();
  const { customerId, error, setError, customerInformationService } = useContext(CustomerContext);
  const [submitting, setSubmitting] = useState(false as boolean);
  const [houseNumber, setHouseNumber] = useState(undefined as string);
  const [houseName, setHouseName] = useState(undefined as string);
  const [flatNumber, setFlatNumber] = useState(undefined as string);
  const [street, setStreet] = useState(undefined as string);
  const [locality, setLocality] = useState(undefined as string);
  const [townOrCity, setTownOrCity] = useState(undefined as string);
  const [county, setCounty] = useState(undefined as string);
  const [postalCode, setPostalCode] = useState(undefined as string);
  const [countryCode, setCountryCode] = useState(undefined as string);

  const onSaveAddress = async () => {
    try {
      setSubmitting(true);
      await customerInformationService.createAddress(
        customerId,
        houseNumber,
        houseName,
        flatNumber,
        street,
        locality,
        townOrCity,
        county,
        postalCode,
        countryCode
      );
      navigate(`/customers/${customerId}`);
    } catch (error) {
      setError({ source: 'Create Address', ...error });
      setSubmitting(false);
    }
  };

  const onCancelAddress = () => {
    navigate(`/customers/${customerId}`);
  };

  return (
    <section>
      <h1>Create Address</h1>
      <Error error={error} setError={setError} />
      <div className="ui form">
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">House Name</div>
            <input
              type="text"
              placeholder="House Name"
              value={houseName || ''}
              disabled={submitting}
              onChange={(e) => setHouseName(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">House Number</div>
            <input
              type="text"
              placeholder="House Number"
              value={houseNumber || ''}
              disabled={submitting}
              onChange={(e) => setHouseNumber(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Flat Number</div>
            <input
              type="text"
              placeholder="Flat Number"
              value={flatNumber || ''}
              disabled={submitting}
              onChange={(e) => setFlatNumber(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Street</div>
            <input
              type="text"
              placeholder="Street"
              value={street || ''}
              disabled={submitting}
              onChange={(e) => setStreet(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Locality</div>
            <input
              type="text"
              placeholder="Locality"
              value={locality || ''}
              disabled={submitting}
              onChange={(e) => setLocality(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Town/City</div>
            <input
              type="text"
              placeholder="Town or City"
              value={townOrCity || ''}
              disabled={submitting}
              onChange={(e) => setTownOrCity(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">County</div>
            <input
              type="text"
              placeholder="County"
              value={county || ''}
              disabled={submitting}
              onChange={(e) => setCounty(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Postal Code *</div>
            <input
              type="text"
              placeholder="Postal Code"
              value={postalCode || ''}
              disabled={submitting}
              onChange={(e) => setPostalCode(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Country Code</div>
            <input
              type="text"
              placeholder="Country Code"
              value={countryCode || ''}
              disabled={submitting}
              onChange={(e) => setCountryCode(e.target.value)}
            />
          </div>
        </div>
        <button
          className={`ui primary button ${submitting && 'loading'}`}
          type="submit"
          onClick={() => onSaveAddress()}>
          Create Address
        </button>
        <button className={'ui secondary button'} onClick={() => onCancelAddress()}>
          Cancel
        </button>
      </div>
    </section>
  );
}
